import { StatelessComponent } from 'react'
import * as styles from 'styles/atoms/balloons/Balloon.css'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { HomePrice } from 'interfaces/property'
import Balloon, { BalloonArrowDirection } from 'components/atoms/balloons/Balloon'

type HomePriceBalloonProps = {
  price: HomePrice
  addressValue: string
  arrowDirection?: BalloonArrowDirection
}

const HomePriceBalloon: StatelessComponent<HomePriceBalloonProps> = (props) => {
  const { arrowDirection, addressValue, price } = props

  return (
    <Balloon centered arrowDirection={ arrowDirection }>
      <div className={ styles.valueExplanation }>
        Zestimate®
      </div>
      <div className={ styles.value }>
        { formatUSCurrency(price.low) } – { formatUSCurrency(price.high) }
      </div>
      <a target='_blank' rel='noopener nofollow' href='http://www.zillow.com/' className={ styles.zillowLogo } />
      <div className={ styles.valueExplanation }>
        See more details for <a target='_blank' rel='noopener nofollow' href={ price.link } className={ styles.link }>{ addressValue }</a> on Zillow
      </div>
    </Balloon>
  )
}

export default HomePriceBalloon
